import React from 'react';
import {
  DocumentTextIcon,
  CheckCircleIcon,
  ExclamationCircleIcon,
  ClockIcon,
} from '@heroicons/react/24/outline';

const DocumentStatisticsCards = ({ documents, stats = {} }) => {
  // Use stats prop if available
  const totalDocuments    = stats.totalDocuments ?? (documents ? documents.length : 0);
  const releasedDocuments = stats.statusCounts ? stats.statusCounts.released : (documents ? documents.filter(d => d.status === 'released').length : 0);
  const pendingDocuments  = stats.statusCounts ? stats.statusCounts.pending : (documents ? documents.filter(d => d.status === 'pending').length : 0);
  const updatedThisMonth  = stats.updatedThisMonth ?? (documents ? documents.filter(d => d.updated_at && new Date(d.updated_at).getMonth() === new Date().getMonth()).length : 0);

  const cards = [
    {
      label:       'Total Documents',
      value:       totalDocuments,
      icon:        DocumentTextIcon,
      bgColor:     'bg-blue-100',
      textColor:   'text-blue-600',
      description: 'All document requests'
    },
    {
      label:       'Released Documents',
      value:       releasedDocuments,
      icon:        CheckCircleIcon,
      bgColor:     'bg-green-100',
      textColor:   'text-green-600',
      description: 'Released documents'
    },
    {
      label:       'Pending',
      value:       pendingDocuments,
      icon:        ClockIcon,
      bgColor:     'bg-yellow-100',
      textColor:   'text-yellow-600',
      description: 'Awaiting approval'
    },
    {
      label:       'Updated This Month',
      value:       updatedThisMonth,
      icon:        ExclamationCircleIcon,
      bgColor:     'bg-teal-100',
      textColor:   'text-teal-600',
      description: 'Modified this month'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-4 mb-8 animate-in slide-in-from-bottom duration-700 delay-200">
      {cards.map((stat) => (
        <div key={stat.label} className="bg-white rounded-lg shadow-lg p-4 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer group">
          <div className="flex items-center flex-shrink-0">
            <div className={`flex items-center mb-3 justify-center w-12 h-12 ${stat.textColor} ${stat.bgColor} text-2xl font-bold rounded-lg group-hover:scale-110 transition-transform duration-200`}>
                {stat.value?.toLocaleString()}
              </div>
            <div className="ml-4">
               <p className="text-sm font-medium text-gray-600">{stat.label}</p>
                <p className="text-xs text-gray-500 mt-1">{stat.description}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default React.memo(DocumentStatisticsCards);
